<template>
  <div class="location">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4 class="mb-3 font-weight-bold kova-text">State your budget for this project</h4>
        <br />
        <h6 class="mb-3 font-weight-bold text-left mt-4 pb-2">Budget amount</h6>

        <a-input-group compact class="text-left mb-3" size="large">
          <a-select v-model="budgetCurrency" default-value="USD" :disabled="disableInput">
            <a-select-option value="USD">USD</a-select-option>
            <a-select-option value="NGN">NGN</a-select-option>
            <a-select-option value="EUR">EUR</a-select-option>
          </a-select>
          <a-input style="width: 50%" v-model="budgetAmount" :disabled="disableInput" />
        </a-input-group>

        <!--   <a-input-number
          id="inputNumber"
          v-model="budgetAmount"
          :precision="number"
          size="large"
          placeholder="500 , 1000"
          class="w-100 mb-3"
        />
        <br />

        <h6 class="mb-3 font-weight-bold text-left mt-4">Currency</h6>

        <a-select
          mode="single"
          class="w-100"
          size="large"
          placeholder="Please select your Currency"
          v-model="budgetCurrency"
        >
          <a-select-option v-for="item in currencies" :key="item">
            {{
            item
            }}
          </a-select-option>
        </a-select>-->

        <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >Back</button>
            </div>
            <div class="col text-right">
              <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next</button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4 mb-5">
        <span @click="skip">
          Skip
          <font-awesome-icon icon="step-forward"></font-awesome-icon>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "budget",
  data() {
    return {
      disableInput:
        this.$store.state.client.clientData.jobtype == "Crowdsource"
          ? true
          : false,
      currencies: ["USD", "NGN", "GBP"],
      budgetAmount: this.$store.state.client.clientData.budgetAmount
        ? this.$store.state.client.clientData.budgetAmount
        : "",
      budgetCurrency: this.$store.state.client.clientData.budgetCurrency
        ? this.$store.state.client.clientData.budgetCurrency
        : ""
    };
  },
  methods: {
    handleChange(value) {
      this.budgetCurrency = value;
    },
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { budgetAmount, budgetCurrency } = this;
      this.$store.commit("client/updateClient", {
        budgetAmount,
        budgetCurrency
      });
      this.$router.push("make-job-post");
    },
    skip() {
      this.$router.push("make-job-post");
    }
  },
  mounted() {}
};
</script>
<style scoped>
.control-width {
  width: 600px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
}
</style>
